module.exports = __webpack_public_path__ + "img/cervejas.2ff2d548.svg";